
import { defineComponent, ref, reactive } from 'vue';
import OverlayModal from '@/views/Modals/OverlayModal.vue';

import { DateRange } from '@/models/Order';
import Multiselect from '@vueform/multiselect';
import Calendar from 'primevue/calendar';
import _ from 'lodash';
import { DateConstants } from '@/models/Constants';
import moment from 'moment';
import InputNumber from 'primevue/inputnumber';
import { CouponLogsFilter } from '@/models/CouponLogs';
import useExtensions from '@/useExtensions';
import { ToOptions, CouponSystem, CouponLogStatus } from '@/models/Enums';

export default defineComponent({
    components: {
        OverlayModal,
        Multiselect,
        Calendar,
        InputNumber
    },
    name: 'CrmCustomersFilterModal',
    async setup(props, { emit }) {
        const dateConstants = DateConstants;
        const isOpen = ref(false);
        const { dateRangeValidate } = useExtensions();
        const createDateRange = reactive(new DateRange());
        const lastOrderDateRange = reactive(new DateRange());
        const filter = ref(new CouponLogsFilter());
        const externalSystems = ToOptions(CouponSystem);
        const couponLogStatus = ToOptions(CouponLogStatus);
        async function open(filterObj: CouponLogsFilter) {
            filter.value = _.clone(filterObj);
            if (filter.value?.createdDateFrom) {
                createDateRange.fromDate = moment(filter.value.createdDateFrom, DateConstants.SERVER_NODATIME_LOCAL_DATE_FORMAT).toDate();
            } else {
                createDateRange.fromDate = null;
            }
            if (filter.value?.createdDateTo) {
                createDateRange.toDate = moment(filter.value.createdDateTo, DateConstants.SERVER_NODATIME_LOCAL_DATE_FORMAT).toDate();
            } else {
                createDateRange.toDate = null;
            }
            isOpen.value = true;
        }
        function close() {
            isOpen.value = false;
        }

        function blockInvalid(e: any) {
            if (['-', '+', 'e', 'E', ',', '.'].includes(e.key)) e.preventDefault();
        }
        function normalizePositive() {
            const v = filter.value.providerId;
            if (filter.value.providerId == null || Number.isNaN(v)) return;
            if (v == null) {
                filter.value.providerId = null;
                return;
            }
            if (v <= 0) filter.value.providerId = null;
        }

        function preventInvalid(e: KeyboardEvent) {
            if (['-', '+', 'e', 'E', ',', '.'].includes(e.key)) e.preventDefault();
        }

        function apply() {
            const toApplyFilter = _.clone(filter.value);
            if (createDateRange.fromDate) {
                toApplyFilter.createdDateFrom = moment(createDateRange.fromDate).format(DateConstants.SERVER_NODATIME_LOCAL_DATE_FORMAT);
            }
            if (createDateRange.toDate) {
                toApplyFilter.createdDateTo = moment(createDateRange.toDate).format(DateConstants.SERVER_NODATIME_LOCAL_DATE_FORMAT);
            }
            emit('applyFilter', toApplyFilter);
            close();
        }
        const dateChanged = (dateRange: DateRange) => {
            if (!dateRange.fromDate || !dateRange.toDate) return;
            dateRangeValidate(dateRange);
        };

        return {
            isOpen,
            open,
            close,
            apply,
            filter,
            createDateRange,
            lastOrderDateRange,
            dateChanged,
            dateConstants,
            externalSystems,
            couponLogStatus,
            preventInvalid,
            normalizePositive,
            blockInvalid
        };
    }
});
